/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { ContextualHelpIcon } from '@coursera/cds-icons';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import { DEFAULT_MAX_PREVIEW_FILE_SIZE_BYTES } from 'bundles/compound-assessments/lib/utils/renderPreviewUtils';

import _t from 'i18n!nls/compound-assessments';

const styles = {
  container: () => css`
    display: flex;
    align-items: center;
    margin: var(--cds-spacing-200) 0;
  `,
  tooltip: () => css`
    display: flex;
  `,
  icon: () => css`
    margin-right: var(--cds-spacing-100);
  `,
};

type Props = {
  fileAvailable: boolean;
  validFileSize: boolean;
};

export const RenderPreviewUnavailable: React.FC<Props> = ({ fileAvailable, validFileSize }) => {
  const tooltipMessage =
    fileAvailable && !validFileSize
      ? _t('File size limit for preview is #{fileSizeLimitMB}MB.', {
          fileSizeLimitMB: Math.floor(DEFAULT_MAX_PREVIEW_FILE_SIZE_BYTES / 1000000),
        })
      : _t('Failed to retrieve file.');

  return (
    <TooltipWrapper message={tooltipMessage} placement="bottom" css={styles.tooltip}>
      <div css={styles.container}>
        <ContextualHelpIcon size="small" css={styles.icon} color="support" />
        <Typography2 color="supportText" component="span">
          {_t('Preview unavailable')}
        </Typography2>
      </div>
    </TooltipWrapper>
  );
};

export default RenderPreviewUnavailable;
